const labelFromKey = (key) =>
  String(key)
    .replace(/([A-Z])/g, " $1")
    .replace(/[._]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/^./, (char) => char.toUpperCase());

const isRequiredTest = (field) =>
  (field.tests || []).some((test) => test.name === "required") ||
  (field.tests || []).some(
    (test) => test.name === "min" && test.params && Number(test.params.min) >= 1
  );

const collectDescribed = (described, prefix, into) => {
  const fields = (described && described.fields) || {};
  Object.keys(fields).forEach((key) => {
    const field = fields[key];
    const path = prefix ? `${prefix}.${key}` : key;
    if (field.innerType && field.innerType.fields) {
      into.push({
        key: path,
        label: labelFromKey(key),
        required: isRequiredTest(field),
      });
      collectDescribed(field.innerType, path, into);
      return;
    }
    into.push({
      key: path,
      label: labelFromKey(key),
      required: isRequiredTest(field),
    });
  });
};

const probeValues = (schema) => {
  const probes = [{}];
  Object.keys(schema.fields || {}).forEach((key) => {
    const deps = schema.fields[key]._deps || [];
    deps.forEach((dep) => {
      probes.push({ [dep]: false });
    });
  });
  return probes;
};

const requiredPaths = (schema) => {
  const required = new Set();
  probeValues(schema).forEach((probe) => {
    try {
      schema.validateSync(probe, { abortEarly: false });
    } catch (error) {
      (error.inner || [error]).forEach((item) => {
        if (item && item.path && (item.type === "required" || item.type === "min")) {
          required.add(item.path);
        }
      });
    }
  });
  return required;
};

export function fieldsFromSchema(schema) {
  if (!schema || !schema.describe) return [];
  const described = [];
  collectDescribed(schema.describe(), "", described);
  const required = requiredPaths(schema);
  return described.map((field) => ({
    ...field,
    required: field.required || required.has(field.key),
  }));
}
